import { simpleOrganizationFragment } from './fragmentsOrganization';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const organizationSetOnboardedMutationAtom = createMutationAtomFactory(
  'admin.organizationSetOnboarded',
  (params: { id: string; onboarded: boolean }) => ({
    coreOrganizationUpdate: {
      __args: {
        id: params.id,
        input: {
          onboardAt: params.onboarded ? new Date().toISOString() : null,
        },
      },
      ...simpleOrganizationFragment,
    },
  }),
);
